import script from "./ViewBasic.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBasic.vue?vue&type=script&setup=true&lang=js"

import "./ViewBasic.vue?vue&type=style&index=0&id=b7d8963c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7d8963c"]])

export default __exports__